// Mock data for attendance and payment records
export const attendanceRecords = [
  {
    id: 1,
    date: '2025-06-22',
    type: 'student',
    name: '陳俊傑',
    nameEn: 'Chan Tsun Hei',
    class: 'S1B',
    action: 'in',
    time: '07:45:32',
    location: '正門',
    method: '學生證',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face',
    status: 'normal'
  },
  {
    id: 2,
    date: '2025-06-22',
    type: 'teacher',
    name: '陳老師',
    nameEn: 'Mr. David Chen',
    class: '',
    action: 'in',
    time: '06:45:12',
    location: '教職員入口',
    method: '員工證',
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=50&h=50&fit=crop&crop=face',
    status: 'normal'
  },
  {
    id: 3,
    date: '2025-06-22',
    type: 'student',
    name: '李美玲',
    nameEn: 'Lee Mei Ling',
    class: 'S1B',
    action: 'in',
    time: '08:15:45',
    location: '正門',
    method: '學生證',
    photo: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face',
    status: 'late'
  },
  {
    id: 4,
    date: '2025-06-22',
    type: 'teacher',
    name: '莊老師',
    nameEn: 'Ms. Sarah Johnson',
    class: '',
    action: 'out',
    time: '16:30:22',
    location: '教職員入口',
    method: '員工證',
    photo: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face',
    status: 'normal'
  },
  {
    id: 5,
    date: '2025-06-21',
    type: 'student',
    name: '黃志明',
    nameEn: 'Wong Chi Ming',
    class: 'S1B',
    action: 'out',
    time: '14:30:15',
    location: '正門',
    method: '學生證',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&h=50&fit=crop&crop=face',
    status: 'early'
  },
  {
    id: 6,
    date: '2025-06-21',
    type: 'teacher',
    name: '劉老師',
    nameEn: 'Mr. Michael Liu',
    class: '',
    action: 'in',
    time: '07:30:08',
    location: '教職員入口',
    method: '員工證',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face',
    status: 'normal'
  },
  {
    id: 7,
    date: '2025-06-21',
    type: 'student',
    name: '王子軒',
    nameEn: 'Wang Zi Xuan',
    class: 'S1B',
    action: 'in',
    time: '07:50:33',
    location: '正門',
    method: '學生證',
    photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=50&h=50&fit=crop&crop=face',
    status: 'normal'
  },
  {
    id: 8,
    date: '2025-06-20',
    type: 'student',
    name: '張雅婷',
    nameEn: 'Zhang Ya Ting',
    class: 'S1B',
    action: 'in',
    time: '07:55:18',
    location: '正門',
    method: '學生證',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=50&h=50&fit=crop&crop=face',
    status: 'normal'
  }
];

export const paymentRecords = [
  {
    id: 'pay001',
    type: '學費',
    description: '2025年第一學期學費',
    amount: 8500,
    currency: 'HKD',
    dueDate: '2025-07-01',
    paymentDate: '2025-06-15',
    status: 'paid',
    method: '銀行轉帳',
    receiptNumber: 'RC2025001',
    studentName: '陳俊傑',
    studentId: 'S1B01',
    category: '學費'
  },
  {
    id: 'pay002',
    type: '書簿費',
    description: '新學年教科書費用',
    amount: 1200,
    currency: 'HKD',
    dueDate: '2025-07-15',
    paymentDate: null,
    status: 'pending',
    method: '',
    receiptNumber: '',
    studentName: '陳俊傑',
    studentId: 'S1B01',
    category: '雜費'
  },
  {
    id: 'pay003',
    type: '校車費',
    description: '2025年7-8月校車費',
    amount: 600,
    currency: 'HKD',
    dueDate: '2025-06-30',
    paymentDate: '2025-06-20',
    status: 'paid',
    method: '現金',
    receiptNumber: 'RC2025002',
    studentName: '陳俊傑',
    studentId: 'S1B01',
    category: '交通'
  },
  {
    id: 'pay004',
    type: '活動費',
    description: '科學展覽會參加費',
    amount: 150,
    currency: 'HKD',
    dueDate: '2025-07-10',
    paymentDate: null,
    status: 'pending',
    method: '',
    receiptNumber: '',
    studentName: '陳俊傑',
    studentId: 'S1B01',
    category: '活動'
  },
  {
    id: 'pay005',
    type: '午膳費',
    description: '7月份午膳費用',
    amount: 800,
    currency: 'HKD',
    dueDate: '2025-06-25',
    paymentDate: null,
    status: 'overdue',
    method: '',
    receiptNumber: '',
    studentName: '陳俊傑',
    studentId: 'S1B01',
    category: '膳食'
  },
  {
    id: 'pay006',
    type: '補習費',
    description: '暑期數學補習班',
    amount: 2000,
    currency: 'HKD',
    dueDate: '2025-07-20',
    paymentDate: null,
    status: 'pending',
    method: '',
    receiptNumber: '',
    studentName: '陳俊傑',
    studentId: 'S1B01',
    category: '補習'
  }
];

export const digitalEquipment = [
  {
    id: 'eq001',
    name: '平板電腦',
    nameEn: 'Tablet',
    model: 'iPad Air',
    category: '平板',
    icon: 'tablet',
    color: '#3b82f6',
    available: 15,
    total: 20,
    location: '電腦室A',
    specifications: '10.9吋螢幕, 64GB儲存',
    bookings: [
      { date: '2025-06-25', time: '09:00-10:30', bookedBy: 'S1A', purpose: '數學課' },
      { date: '2025-06-26', time: '14:00-15:30', bookedBy: 'S2B', purpose: '科學實驗' }
    ]
  },
  {
    id: 'eq002',
    name: '筆記型電腦',
    nameEn: 'Laptop',
    model: 'MacBook Air',
    category: '電腦',
    icon: 'monitor',
    color: '#10b981',
    available: 8,
    total: 12,
    location: '電腦室B',
    specifications: '13吋螢幕, 256GB SSD',
    bookings: [
      { date: '2025-06-24', time: '10:00-11:30', bookedBy: 'S3C', purpose: '程式設計' },
      { date: '2025-06-27', time: '13:00-14:30', bookedBy: 'S4A', purpose: '多媒體製作' }
    ]
  },
  {
    id: 'eq003',
    name: '智能手機',
    nameEn: 'Smartphone',
    model: 'iPhone 13',
    category: '手機',
    icon: 'smartphone',
    color: '#f59e0b',
    available: 5,
    total: 8,
    location: '媒體中心',
    specifications: '6.1吋螢幕, 128GB儲存',
    bookings: [
      { date: '2025-06-25', time: '15:00-16:00', bookedBy: 'S5B', purpose: '影片拍攝' }
    ]
  },
  {
    id: 'eq004',
    name: '數位相機',
    nameEn: 'Digital Camera',
    model: 'Canon EOS M50',
    category: '攝影',
    icon: 'camera',
    color: '#ef4444',
    available: 3,
    total: 5,
    location: '攝影室',
    specifications: '24MP感光元件, 4K錄影',
    bookings: [
      { date: '2025-06-26', time: '11:00-12:30', bookedBy: 'S4C', purpose: '新聞攝影' }
    ]
  },
  {
    id: 'eq005',
    name: '無線耳機',
    nameEn: 'Wireless Headphones',
    model: 'AirPods Pro',
    category: '音響',
    icon: 'headphones',
    color: '#8b5cf6',
    available: 20,
    total: 25,
    location: '語言實驗室',
    specifications: '主動降噪, 無線充電',
    bookings: [
      { date: '2025-06-24', time: '08:00-09:30', bookedBy: 'S2A', purpose: '英語聽力' },
      { date: '2025-06-25', time: '10:00-11:30', bookedBy: 'S1C', purpose: '音樂欣賞' }
    ]
  }
]; 